<template>
  <b-container fluid class="login">
    <b-row>
      <b-col style="padding: 0px;">
        <div class="text-center login-banner" v-bind:style="{background: 'url(' + getImage(bannerImg, 'banner') +')'}" >
          <div class="title-top text-uppercase">Duta Sarana Konstruksi</div>
          <center>
            <div class="title-bottom">
              <div class="fieldWrapper">
                <input type="text" placeholder="Username" v-model="username">
                <div class="prefixIcon"><i class="material-icons">person_pin</i></div>
              </div>
              <div class="fieldWrapper">
                <input type="password" placeholder="Password" v-model="password">
                <div class="prefixIcon"><i class="material-icons">visibility</i></div>
              </div>
              <div class="loginBtn p-2 text-center text-uppercase" v-on:click="login">
                Login
              </div>
            </div>
          </center>
        </div>
      </b-col>
    </b-row>
</b-container>
</template>

<script>
import util from '@/util'

export default {
  name: 'Login',
  data () {
    return {
      errors: [],
      username: '',
      password: '',
      bannerImg: 'dsk-home-bg.jpg'
    }
  },
  methods: {
    getImage (imageName, section) {
      return util.getImage(imageName, section)
    },
    login () {
      if (this.validateLogin()) {
        this.$store.dispatch('login', {
          data: {
            username: this.$data.username,
            password: this.$data.password
          },
          success: (res) => {
            console.log('response body login ', res.body)
            this.$cookies.set('uses', this.$data.username, '1d')
            this.$cookies.set('a', res.body, '1d')
            this.toast('Hi there!', 'success', 'check')
            this.$router.push('/dashboard')
          },
          fail: () => {
            console.log('failed to login')
            this.toast('Invalid username or password', 'error', 'error_outline')
          }
        })
      } else {
        this.toast(this.$data.errors[0], 'error', 'error_outline')
      }
    },
    validateLogin () {
      if (this.$data.username === '' || this.$data.username === undefined || this.$data.username.trim() === '' ||
          this.$data.password === '' || this.$data.password === undefined || this.$data.password.trim() === '') {
        this.$data.errors.push('Invalid username or password.')
        return false
      }
      return true
    },
    toast (msg, type, icon) {
      this.$toasted.show(msg, {
        theme: 'bubble',
        position: 'top-center',
        fullWidth: true,
        type: type,
        icon: icon,
        duration: 2000
      })
    }
  }
}
</script>

<style scoped>
.login-banner {
  background-size: cover;
  min-height: 95vh;
  color: #fff;
}
.title-top {
  padding-top: 25vh;
  font-size: 1.2em;
  font-weight: bold;
  letter-spacing: 0.6em;
}
.title-middle {
  padding-top: 50px;
  font-size: 2em;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  font-weight: bolder;
  letter-spacing: 5px;
}
.title-bottom {
  padding: 40px 10px 20px 10px;
  max-width: 450px;
  font-size: 1.2em;
}
.fieldWrapper {
  background-color: #fff;
  overflow: hidden;
  position: relative;
	display: inline;
}
.fieldWrapper input {
  border: none;
  border-bottom: 1px solid #000;
  padding: 10px 10px 10px 70px;
  width: 100%;
  outline: none;
  line-height: 1.5;
  margin-bottom: 15px;
}
.prefixIcon {
  background-color: #FF8F00;
  position: absolute;
  top: -11px;
  bottom: -11px;
  font-size: 2em;
  padding: 0px 20px;
  color: #fff;
}
.loginBtn {
  width: 100%;
  background-color: #FF8F00;
  color: #FFF;
  -webkit-transition: 300ms ease-in;
  -moz-transition: 300ms ease-in;
  -o-transition: 300ms ease-in;
  transition: 300ms ease-in;
}
.loginBtn:hover {
  cursor: pointer;
  background-color: #FFA000;
  color: #000;
}
</style>



// WEBPACK FOOTER //
// src/components/Login.vue